import GenerateAPI from "../generate.js";

let config = {
	getToken: {
		url: "/client/wx/getToken",
		apiType: "check"
	}
};

const apiHomePage = GenerateAPI.generate(config);

export default apiHomePage;
